import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ toggleDarkMode, isDarkMode }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDialogueOpen, setIsDialogueOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    const handleClickOutside = (event) => {
      if (isDialogueOpen) {
        const dialogueBox = document.getElementById('dialogue-box');
        if (dialogueBox && !dialogueBox.contains(event.target)) {
          setIsDialogueOpen(false);
        }
      }

      const Menu = document.getElementById('navbar-with-mega-menu');
      const menuButton = document.querySelector('button[aria-label="Toggle navigation"]');
      if (
        isMenuOpen &&
        Menu &&
        !Menu.contains(event.target) &&
        menuButton &&
        !menuButton.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDialogueOpen, isMenuOpen]);

  return (
    <div>
      {/* Sidebar for PC */}
      <aside className="fixed left-0 top-0 h-full w-[250px] dark:bg-[#191919] dark:border-[#000000] bg-white border-r border-gray-300 p-6 hidden md:block">
        <div className="mb-6 mt-6 pl-2">
          <button>
            <Link to="/">
              <p className="bg-[#e4e4e4] text-[#424243] dark:bg-black dark:text-white px-4 py-2 text-3xl font-bold inline-block rounded-sm ">海瑠</p>
            </Link>
          </button>
        </div>
        <nav className="pl-2">
          <Link to="/about" className="block text-lg font-semibold text-gray-900 hover:underline dark:text-white">About</Link>
          <Link to="/ideas" className="block text-lg font-semibold text-gray-900 hover:underline dark:text-white">Works</Link>
          <Link to="/cv" className="block text-lg font-semibold text-gray-900 hover:underline dark:text-white">CV</Link>
        </nav>
        <div className="pl-2 mt-10 space-y-6 text-sm text-gray-500">
          <div>
            <p className="font-bold uppercase tracking-wider text-gray-400 dark:text-white mb-2">Portfolio</p>
            <Link to="/" className="block hover:underline dark:text-gray-400">Designs</Link>
            <Link to="/" className="block hover:underline dark:text-gray-400">Projects</Link>
            <Link to="/" className="block hover:underline dark:text-gray-400">Photography</Link>
            <Link to="/" className="block hover:underline dark:text-gray-400">Arts</Link>
          </div>
          <div>
            <p className="font-bold uppercase tracking-wider text-gray-400 mb-2 dark:text-white">Contact</p>
            <a href="mailto:kylearce25@gmail.com" className="block hover:underline dark:text-gray-400">Mail</a>
            <Link to="https://github.com/Kaireu" className="block hover:underline dark:text-gray-400" target="_blank" rel="noopener noreferrer">Github</Link>
            <Link to="https://www.linkedin.com/in/josh-kyle-arce-44b46832a" className="block hover:underline dark:text-gray-400" target="_blank" rel="noopener noreferrer">LinkedIn</Link>
            <Link to="https://www.instagram.com/arceuu/" className="block hover:underline dark:text-gray-400" target="_blank" rel="noopener noreferrer">Instagram</Link>
          </div>
          <div>
            <p className="font-bold uppercase tracking-wider text-gray-400 dark:text-white mb-2">Change Theme</p>
            <button
              onClick={toggleDarkMode}
              className="p-2 text-2xl text-purple dark:text-yellow-100"
            >
              {isDarkMode ? '☼' : '☾'}
            </button>
          </div>
        </div>
      </aside>
      
      {/*  Menu */}
      <div className="md:hidden">
        <header className={`dark:bg-[#19191916] bg-[#ffffff16] fixed w-full py-2 transition-all duration-300 z-50 backdrop-blur-sm  ${isScrolled ? 'bg-darkGray/7 shadow-lg' : 'bg-darkGray/7'}`}>
          <nav className="max-w-[48rem] w-full mx-auto" aria-label="Global">
            <div className="flex items-center justify-between w-full px-4">
              <Link to="/">
                <div className="pl-[1rem] py-2 pr-[1rem]">
                  <p className="bg-[#e4e4e4] text-[#424243] dark:bg-[black] dark:text-white rounded-sm p-4 py-2 text-2xl font-bold">海瑠</p></div>
              </Link>
              
              <div className="flex items-center gap-3">
                <button
                  onClick={toggleDarkMode}
                  className="p-2 text-2xl text-purple dark:text-yellow-100"
                >
                  {isDarkMode ? '☼' : '☾'}
                </button>
                <button
                  type="button"
                  className="p-2 inline-flex justify-center items-center gap-x-2 rounded-lg border dark:border-[#202023] bg-white text-blak shadow-sm hover:bg-white disabled:opacity-50 disabled:pointer-events-none dark:bg-transparent dark:text-black dark:hover:bg-white/10 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-white"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  aria-label="Toggle navigation"
                >
                  <svg className={`flex-shrink-0 w-4 h-4 text-[#202023] dark:text-gray-500 stroke-current ${isMenuOpen ? 'hidden' : ''}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" x2="21" y1="6" y2="6" /><line x1="3" x2="21" y1="12" y2="12" /><line x1="3" x2="21" y1="18" y2="18" /></svg>

                  <svg className={`flex-shrink-0 w-4 h-4 text-[#202023] dark:text-gray-500  stroke-current ${isMenuOpen ? '' : 'hidden'}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                </button>
              </div>
            </div>
            <div id="navbar-with-mega-menu" className={`hs-collapse overflow-hidden transition-all duration-300 w-full ${isMenuOpen ? 'block' : 'hidden'}`}>
              <div className="pb-2 flex flex-col gap-5 mt-5 md:flex-row md:items-center md:justify-end md:mt-0 md:ps-5">
                <Link to="/">
                  <button className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none">About</button>
                </Link>
                <Link to="/ideas">
                  <button className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none">Works</button>
                </Link>
                <Link to="/cv">
                  <button className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none">CV</button>
                </Link>

                <p className="pl-[1rem] text-lg font-medium text-black dark:text-white dark:focus:outline-none mt-5">Contact</p>

                <a href="mailto:kylearce25@gmail.com" className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none">Mail</a>
                <Link to="https://github.com/Kaireu" className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none" target="_blank" rel="noopener noreferrer">Github</Link>
                <Link to="https://www.linkedin.com/in/josh-kyle-arce-44b46832a" className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none" target="_blank" rel="noopener noreferrer">LinkedIn</Link>
                <Link to="https://www.instagram.com/arceuu/" className="pl-[1rem] text-lg font-light text-black dark:text-white hover:text-gray-40 dark:hover:text-gray-500 dark:focus:outline-none" target="_blank" rel="noopener noreferrer">Instagram</Link>
              </div>
            </div>
          </nav>
        </header>
      </div>
    </div>
  );
};

export default Navbar;
